export default __webpack_public_path__ + "static/Norah-09d6ae142d360f1e1e941d51e0319259998dfdbc48ea5ece91d10863d7ff9b52.svg";